import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import { TASK_DESCRIPTION_MAX } from "@recobra/schemas/task";

import type { TaskCreationFormApi } from "./useTaskCreationForm";

/** Free-text context the creator adds to the request, stored as the task description. */
export const TaskObservationSection: FC<{ form: TaskCreationFormApi }> = ({ form }) => (
  <form.AppField name="description">
    {(field) => (
      <field.TextAreaField
        id="task-observation"
        label={m.task_field_description()}
        rows={3}
        maxLength={TASK_DESCRIPTION_MAX}
      />
    )}
  </form.AppField>
);
